export default __webpack_public_path__ + "static/media/1_0076.bab9287a.webp";